var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsNumber, IsOptional } from 'class-validator';
import { ValidateReservationDriverLicenseAndUpdateDto } from './validate-reservation-driver-license-and-update.dto';
export class ValidateReservationDriverLicenseDto extends ValidateReservationDriverLicenseAndUpdateDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ValidateReservationDriverLicenseDto.prototype, "vehicleModelId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], ValidateReservationDriverLicenseDto.prototype, "pickUpAt", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ValidateReservationDriverLicenseDto.prototype, "vendorId", void 0);
__decorate([
    IsNumber({}, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ValidateReservationDriverLicenseDto.prototype, "insuranceIds", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ValidateReservationDriverLicenseDto.prototype, "insuranceOption", void 0);
